export default (val) => {
    var arr = val.trim().split(/[\r\n\s]+/);
    var result = [];
    arr.map(item => {
        item.trim().split("\t")[0] ? result.push(item.trim().split("\t")[0]) : ''
    })
    return result;
}